(function($, undefined) {
	'use strict';
	var utils;
	var locationsUtils;
	
	var init = function() {
		utils = Fw.component.models().utils;
		locationsUtils = Fw.component.models().locationsUtils;
		
		$('.submit-location-site-plan-form').on('click', onSaveSitePlan);
		$('.location-site-plan-edit-btn').on('click', onEditLocationSitePlan);
	};
	
	function onSaveSitePlan() {
		var form = $('.add-location-site-plan-form');
		var fileInput = $('input[type=file]', form);
		var select = $('select', form);
		form.removeClass('has-error');
		fileInput.removeClass('error');
		select.removeClass('error');
		var title = select.val();
		var titleText = select.find('option:selected').text();
		
		if (fileInput[0].files.length === 0) {
			fileInput.addClass('error');
			form.addClass('has-error');
		}
		if (select.val().length === 0) {
			select.addClass('error');
			form.addClass('has-error');
		}
		
		var isEditing = $('[name=sitePlanId]', form).val().length > 0;
		if (!form.hasClass('has-error') || isEditing) {
			var doUpload = !isEditing || fileInput[0].files.length > 0;
			
			locationsUtils.addOverlay();
			if (doUpload) {
				utils.uploadSecureFiles(fileInput[0].files, (response) => {
					const [id, filename] = response.media.mediaIds[0].split(" - ");
					if (isEditing) {
						editCurrentSitePlan($('[name=sitePlanId]', form).val(), title, titleText, id, filename);
						saveCurrentSitePlans();
					} else {
						saveNewSitePlan(id, filename, title);
						appendNewSitePlanRow(id, filename, title, titleText);
					}
				}, form.attr('data-location-id'), "site-plan", utils.UPLOAD_KEY);
			}
			else {
				editCurrentSitePlan($('[name=sitePlanId]', form).val(), title, titleText);
				saveCurrentSitePlans();
			}
		}
		else {
			saveCurrentSitePlans();
		}
	}
	
	function onEditLocationSitePlan() {
		var btn = $(this);
		var row = btn.closest('.table__tr');
		var id = btn.attr('data-id');
		var form = $('.add-location-site-plan-form');
		$('select', form).val($('.table__td', row).eq(0).attr("data-value"));
		
		
		var uploadInput = $('.upload-input', form);
		uploadInput.addClass('upload-input_completed');
		$('.upload-input__placeholder', uploadInput).text($('.table__td', row).eq(2).text());
		$('[name=sitePlanId]', form).val(row.attr("data-value"));
	}
	
	function getCurrentSitePlans() {
		var table = $('.table_location-site-plans');
		var rows = $('.table__tr:not(.template):not(.table__tr_head)', table);
		var sitePlans = $.map(rows, (el) => {
			return {
				"title": $('.table__td', el).eq(0).attr('data-value'),
				"filename": $('.table__td', el).eq(2).attr('data-value'),
				"id": $(el).attr('data-value')
			}
		});
		return sitePlans;
	}
	
	function saveCurrentSitePlans() {
		var sitePlans = getCurrentSitePlans();
		saveSitePlans(sitePlans);
	}
	
	function saveNewSitePlan(id, filename, title) {
		var sitePlans = getCurrentSitePlans();
		sitePlans.push({
			"title": title,
			"filename": filename,
			"id": id
		});
		saveSitePlans(sitePlans);
	}
	
	function saveSitePlans(sitePlansJson) {
		var form = $('.location-form-content');
		const data = {
			id: form.find('[name="id"]').val(),
			field15: JSON.stringify(sitePlansJson)
		};
		locationsUtils.addOverlay();
		locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
			if (id != null) {
				form.find('[name="id"]').val(id);
				locationsUtils.showMessage(form, '_success');
				form.find('.add-location-info__client_hidden')
					.removeClass('add-location-info__client_hidden')
					.find('input')
					.val(id);
			} else {
				locationsUtils.showMessage(form, '_server');
			}
			location.reload();
		});
	}
	
	function appendNewSitePlanRow(id, filename, title, titleText) {
		var table = $('.table_location-site-plans');
		var newRow = $('.table__tr.template:not(.table__tr_head)', table).clone(true);
		$('.table__td', newRow).eq(0).text(titleText);
		$('.table__td', newRow).eq(0).attr('data-value', title);
		$('.table__td', newRow).eq(2).text(filename.substr(filename.indexOf('-') + 1));
		$('.table__td', newRow).eq(2).attr('data-value', filename);
		$('.table__btn_delete', newRow).attr('data-item-id', id);
		$('.table__btn_edit', newRow).attr('data-id', id);
		newRow.attr('data-id', 'location-site-plan-row-' + id);
		newRow.attr('data-value', id);
		newRow.removeClass('template');
		table.append(newRow);
	}
	
	function editCurrentSitePlan(id, title, titleText, newId = "", filename = "") {
		var table = $('.table_location-site-plans');
		var rowToEdit = $('.table__tr', table).filter('[data-value=' + id +']');
		
		$('.table__td', rowToEdit).eq(0).text(titleText);
		$('.table__td', rowToEdit).eq(0).attr('data-value', title);
		if (filename.length > 0) {
			$('.table__td', rowToEdit).eq(2).text(filename.substr(filename.indexOf('-') + 1));
			$('.table__td', rowToEdit).eq(2).attr('data-value', filename);
		}
		if (newId.length > 0) {
			$('.table__btn_delete', rowToEdit).attr('data-item-id', newId);
			$('.table__btn_edit', rowToEdit).attr('data-id', newId);
			rowToEdit.attr('data-id', 'location-site-plan-row-' + newId);
			rowToEdit.attr('data-value', newId);
		}
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
